<ul *ngIf="ipa" class="ukata-ul-no-padding">
  <li *ngFor="let singleIpa of ipa | keyvalue">
    <p>{{ singleIpa.key }}</p>
    <p *ngFor="let ip of singleIpa.value">
      <span class="ipa" matTooltip="ipa">{{ ip.ipa }}</span>
      <span class="phonemes" matTooltip="phonemes">{{ ip.phonemes }}</span>
    </p>
  </li>
</ul>
